import * as ActionConfigurationManager from './config.actions';

export const loadProductDisclaimers = ActionConfigurationManager.LOAD_PRODUCT_DISCLAIMERS;
export const loadProductDisclaimersSuccess = ActionConfigurationManager.LOAD_PRODUCT_DISCLAIMERS_SUCCESS;
export const loadProductDisclaimersFailed = ActionConfigurationManager.LOAD_PRODUCT_DISCLAIMERS_FAILED;
